/** @format */

import process from "process";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import i18n from "../Langues/i18n";
import { apiRequest } from "../Component/Utils/ApiHundler";

const API_BASE_URL = process.env.REACT_APP_API_URL;

export async function createInstanceAndDocs(
  instanceNameOrId,
  modelId,
  files,
  token,
  isNewInstance,
  fileJSONs = null,
  iExpectedDocs = null,
  sFinalCustomer,
  ExistingFinalCustomer
) {
  let instanceId;
  let instanceName;

  // Vérifier si on doit créer une nouvelle instance ou utiliser une existante
  if (isNewInstance) {
    // Créez une nouvelle instance
    const createInstanceResponse = await createInstance(
      instanceNameOrId,
      modelId,
      iExpectedDocs,
      token,
      sFinalCustomer
    );

    if (createInstanceResponse.statusCode !== 200) {
      throw new Error("Erreur lors de la création de l'instance.");
    }

    instanceId = createInstanceResponse.message.InstanceId;
    instanceName = createInstanceResponse.message.InstanceName;
  } else {
    // Utiliser l'instance existante
    instanceId = instanceNameOrId;

    if (ExistingFinalCustomer !== sFinalCustomer || ExistingFinalCustomer === "multi") {
      updateInstanceDataImport(token, instanceId, "multi");
    }
  }
  Cookies.set("instanceId", instanceId);

  // Upload des documents dans l'instance (nouvelle ou existante)
  for (let i = 0; i < files.length; i++) {
    const file = files[i];
    const fileName = file.name;
    const fileType = file.type;

    const createDocsResponse = await createDocs(
      instanceId,
      fileName,
      fileType,
      token,
      fileJSONs[i],
      sFinalCustomer
    );

    if (createDocsResponse.statusCode === 200) {
      const presignedUrl = createDocsResponse.message.PresignedURL;

      // Upload physique du fichier
      await uploadDoc(file, presignedUrl).then((response) => {});
    } else {
      throw new Error(
        `Erreur lors de la création du document pour le fichier ${fileName}.`
      );
    }
  }

  return { instanceId, instanceName };
}

export async function createInstance(
  instanceName,
  modelId,
  exeptedDocs,
  token,
  sFinalCustomer
) {
  var instance = instanceName;
  var raw = JSON.stringify({
    ModelId: modelId,
    InstanceName: instance,
    ExpectedDocs: Number(exeptedDocs),
    FinalCustomer: sFinalCustomer,
    Options: {
      OutputAs: "json",
    },
  });

  return await apiRequest(API_BASE_URL + "/process/create", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    body: raw,
  });
}

async function createDocs(
  instanceId,
  filename,
  filetype,
  token,
  json = "",
  finalcustomer = ""
) {
  let jsonData;

  try {
    jsonData =
      typeof json === "string" && json.trim() !== "" ? JSON.parse(json) : json;
  } catch (error) {
    console.error("⚠️ Erreur de parsing JSON :", error);
    jsonData = {};
  }

  return await apiRequest(API_BASE_URL + "/document/s3upload", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    body: JSON.stringify({
      InstanceId: instanceId,
      FileName: filename,
      FileType: filetype,
      FinalCustomer: finalcustomer,
      InputData: jsonData,
    }),
  });
}

// ⚠️ Ne pas migrer vers apiRequest : upload direct vers une URL S3 pré-signée
async function uploadDoc(file, signedUrl) {
  var mypresignedurl = signedUrl;
  var requestOptions = {
    method: "PUT",
    body: file,
    headers: {
      "Content-Type": file.type,
      "Content-Length": file.length,
    },
  };

  const response = await fetch(mypresignedurl, requestOptions);
  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response.status}`);
  }
}

export async function updateInstanceDataImport(
  token,
  instanceId,
  finalCustomer
) {
  const url = API_BASE_URL + "/process/update/";

  const data = await apiRequest(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    body: JSON.stringify({
      InstanceId: instanceId,
      FieldList: {
        sFinalCustomer: finalCustomer,
      },
    }),
  });

  toast.success(i18n.t('instanceUpdatedSuccess'));

  return data;
}